<script>
  import { isBrowser } from '@st-graphics/graphics-kit/environment'
  import { isPremium, premiumClient, user } from '@st-graphics/graphics-kit/state'
  import { parseLongForm } from '@st-graphics/graphics-components/utils'

  import { ArticleBody, ArticleFoot, ArticleHead } from '$components'
  import SideNav from './SideNav.svelte'
  import Discover from './Discover.svelte'

  let { copy = undefined, id = undefined, class: className, menu } = $props()

  let { copyId, credits, related, sections, share, sidenav, meta, title, header } = $derived(copy)

  $effect(() => {
    if (isBrowser && isPremium.current && premiumClient.current && user.isSubscriber) {
      premiumClient.current.fetchContent(`${copyId}.json`).then((data) => {
        // TODO: Parse custom components.
        const premiumCopy = parseLongForm(data)
        // TODO: Hydrating only the body because that’s where premium changes happen,
        // but doing for all components, might be a hybrid solution for breaking news.
        sections = premiumCopy.sections
      })
    }
  })
</script>

<article {id} class={`article ${className ? className : ''}`}>
  {#if header.mode === 'discover'}
    <Discover {credits} head={header} {sections} />
  {:else}
    <ArticleHead {credits} head={header} {menu} />

    {#if sidenav}
      <div class="article-body--sidenav">
        <SideNav {...sidenav} />

        <div class="article-body-footer-container">
          <ArticleBody {sections} />
          <ArticleFoot {credits} {related} {share} {meta} {title} />
        </div>
      </div>
    {:else}
      <ArticleBody {sections} />
      <ArticleFoot {credits} {related} {share} {meta} {title} />
    {/if}
  {/if}
</article>
